import React from 'react';
import './App.css';
import Layout from './components/Layout/Layout';
import Turntable from './containers/Turntable/Turntable';

function App() {
  return (
    <div className="App">
      <Layout>
        <Turntable />
      </Layout>
    </div>
  );
}

export default App;
